<template>
  <div class="page0">
    <div class="landscape" @touchmove.prevent>
      <div class="lcx">
        <img class="phoPic" src="../../static/img/phone.png" alt="" />
        <div class="word">为了更好的体验，请锁定屏幕后浏览</div>
      </div>
    </div>
    <div class="main">
      <div class="bg"></div>
      <img class="intro" src="../../static/img/page0-intro.png" alt="" />
      <img
        @click="jump"
        class="btn"
        src="../../static/img/page0-btn.png"
        alt=""
      />
      <img class="product" src="../../static/img/product.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    jump() {
      this.$router.push("/page1");
    },
  },
  mounted() {
    let Main = document.querySelector(".main");
    let MainW = Main.getBoundingClientRect().width;
    Main.style.height = (MainW / 750) * 1500 + "px";

    var screenDirection = window.matchMedia("(orientation: portrait)");
    screenDirection.addListener(handleOrientationChange);
    handleOrientationChange(screenDirection);
    function handleOrientationChange(screenDirection) {
      if (screenDirection.matches) {
        console.log("竖屏");
      } else {
        console.log("横屏");
        let landscape = document.querySelector(".landscape");
        let landscapeH =
          document.documentElement.scrollTop || document.body.scrollTop;
        landscape.style.top = landscapeH + "px";
      }
    }
  },
};
</script>

<style scoped>
.page0 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.page0 .main {
  position: absolute;
  left: 0;
  top: -100%;
  bottom: -100%;
  margin: auto;
  width: 100%;
  height: auto;
}
.page0 .bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url("../../static/img/page0-bg.jpg");
  background-size: 100% 100%;
}
.intro {
  position: absolute;
  width: 60%;
  top: 16%;
  left: 23%;
  /* width: 98.93%;
  top: 37%;
  left: 0.535%; */
  animation: up 0.5s linear 1;
  animation-fill-mode: forwards;
}
.btn {
  position: absolute;
  width: 16.53%;
  top: 67%;
  left: 6%;
  /* width: 42.4%;
  top: 62%;
  left: 28.8%; */
  animation: begin 2s linear infinite;
}
.product {
  position: absolute;
  width: 7.2%;
  top: 31%;
  left: 83%;
  /* width: 31.6%;
  top: 47%;
  right: 25%; */
  opacity: 0;
  animation: up2 0.5s 0.5s linear 1;
  animation-fill-mode: forwards;
}
@keyframes begin {
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes up {
  0% {
    top: 36%;
    opacity: 0;
  }
  100% {
    top: 16%;
    opacity: 1;
  }
}
@keyframes up2 {
  0% {
    top: 11%;
    opacity: 0;
  }
  100% {
    top: 31%;
    opacity: 1;
  }
}

/*横屏提示*/

.landscape {
  position: absolute;
  width: 100%;
  background: #000;
  z-index: 999;
  box-sizing: border-box;
}
.landscape .lcx {
  width: 25rem;
  height: 18rem;
  margin-top: 6rem;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}
.landscape .lcx .phoPic {
  position: absolute;
  left: 35%;
  animation-name: rotate;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  transform-origin: center center;
}
.landscape .lcx .word {
  position: absolute;
  bottom: 40%;
  right: 10%;
  text-align: center;
  font-size: 20px;
  color: #ffffff;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(100deg);
  }
}
/* Mobile Landscape Size to Tablet Portrait (devices and browsers) */
@media only screen and (min-width: 480px) and (max-width: 767px) and (orientation: landscape) {
  .landscape {
    display: block;
  }
}
/* Mobile Portrait Size to Mobile Landscape Size (devices and browsers) */
@media only screen and (max-width: 479px) and (orientation: portrait) {
  .landscape {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page0.vue